import { Button, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/itemCategories/reservationQuestions";
import { Delete, Edit } from "@mui/icons-material";
import destroy from "../../../api/auth/itemCategories/reservationQuestions/destroy";
import WushSortableTable from "../../layout/WushSortableTable";
import useReservationQuestionStore from "../../../stores/useReservationQuestionStore";
import ReservationQuestionForm from "../reservationQuestions/ReservationQuestionForm";

export default function ReservationQuestions({ itemCategory }) {
  const [ editingQuestion, setEditingQuestion ] = useState();
  const { reservationQuestions, setReservationQuestions, removeReservationQuestion } = useReservationQuestionStore();

  useEffect(() => {
    index(itemCategory.id, (response) => {
      setReservationQuestions(response);
    });
  }, []);

  const handleDelete = (reservationQuestion) => {
    destroy(itemCategory.id, reservationQuestion.id, () => {
      removeReservationQuestion(reservationQuestion);
    });
  };

  return (
    <Stack>
      <Stack direction="row" spacing={2}>
        <Typography variant="h5">Reservation questions</Typography>
      </Stack>
      <Stack mb={2}>
        <Typography variant="body1">
          Reservation questions are questions that will be asked when a reservation is made for this category.
        </Typography>
      </Stack>
      <Stack direction="row" mb={2}>
        <Button variant="contained" onClick={() => setEditingQuestion({})}>
          New Reservation Question
        </Button>
      </Stack>
      <Stack>
        <WushSortableTable
          headers={[
            {
              key: "question",
              label: "Name"
            },
            {
              label: "Type",
              customValue: (row) => row.answer_data_type
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row">
                  <IconButton onClick={() => setEditingQuestion(row)}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(row)}>
                    <Delete />
                  </IconButton>
                </Stack>
              )
            },
          ]}
          data={reservationQuestions}
        />
      </Stack>
      <Dialog
        open={editingQuestion}
        onClose={() => setEditingQuestion(null)}
      >
        <Stack
          p={2}
          width={{ xs: "100%", sm: "500px" }}
        >
          <Stack mb={2}>
            <Typography variant="h4">{editingQuestion?.id ? "Edit question" : "New question"}</Typography>
          </Stack>
          <ReservationQuestionForm
            reservationQuestion={editingQuestion}
            itemCategory={itemCategory}
            afterCreate={() => setEditingQuestion(null)}
            afterUpdate={() => setEditingQuestion(null)}
          />
        </Stack>
      </Dialog>
    </Stack>
  );
}